export default __webpack_public_path__ + "static/media/route-end.44859d43.svg";